'use client'

import MenuIcon from '@mui/icons-material/Menu'
import { AppBar, Box, Container, Drawer, IconButton, List, ListItem, ListItemButton, ListItemText, Stack, Toolbar, Typography } from '@mui/material'
import Image from 'next/image'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { ReactElement, useEffect, useState } from 'react'

// Navigation menu items
const navItems = [
	{ label: 'Fitur', href: '/#feature-container' },
	{ label: 'Alur Kerja', href: '/#process-container' },
	{ label: 'FAQ', href: '/#faq-container' }
]

export const HeaderSection = (): ReactElement => {
	const [mobileOpen, setMobileOpen] = useState(false)
	const [scrolled, setScrolled] = useState(false)
	const pathname = usePathname()
	const isHomePage = pathname === '/'

	const handleDrawerToggle = () => {
		setMobileOpen((prevState) => !prevState)
	}

	useEffect(() => {
		const handleScroll = () => {
			const heroSection = document.getElementById('main-hero-title-container') // Assuming the main-hero-title-container has this ID
			if (heroSection) {
				const heroSectionBottom = heroSection.getBoundingClientRect().top
				setScrolled(heroSectionBottom <= 100)
			}
		}

		window.addEventListener('scroll', handleScroll)
		return () => {
			window.removeEventListener('scroll', handleScroll)
		}
	}, [])

	return (
		<AppBar position='sticky' color={scrolled || !isHomePage ? 'inherit' : 'transparent'} elevation={scrolled || !isHomePage ? 2 : 0} className='transition-all h-28'>
			<Container maxWidth='lg' className='p-4'>
				<Toolbar className='justify-between items-center w-full mx-auto'>
					<Link href='/'>
						<Image src={'/assets/images/logo-dark.svg'} alt={'logo'} width={200} height={0} style={{ height: 'auto' }} />
					</Link>

					<Box sx={{ display: { xs: 'none', md: 'block' } }}>
						<Stack direction='row' spacing={6.25} alignItems='center'>
							<Stack direction='row' spacing={4} alignItems='center'>
								{navItems.map((item) => (
									<Typography key={item.label} component='a' href={item.href} className={`font-semibold text-base text-black`}>
										{item.label}
									</Typography>
								))}
							</Stack>
						</Stack>
					</Box>

					<IconButton color='inherit' aria-label='open drawer' edge='start' onClick={handleDrawerToggle} sx={{ display: { md: 'none' } }}>
						<MenuIcon className='text-black' />
					</IconButton>
				</Toolbar>
			</Container>

			<nav>
				<Drawer
					variant='temporary'
					open={mobileOpen}
					onClose={handleDrawerToggle}
					ModalProps={{
						keepMounted: true // Better open performance on mobile.
					}}
					sx={{
						'display': { xs: 'block', md: 'none' },
						'& .MuiDrawer-paper': { boxSizing: 'border-box', width: 240 }
					}}>
					<Box onClick={handleDrawerToggle} sx={{ textAlign: 'left' }}>
						<List>
							{navItems.map((item) => (
								<ListItem key={item.label} disablePadding>
									<ListItemButton sx={{ textAlign: 'left' }} href={item.href}>
										<ListItemText primary={item.label} className='text-lg font-bold' />
									</ListItemButton>
								</ListItem>
							))}
						</List>
					</Box>
				</Drawer>
			</nav>
		</AppBar>
	)
}
